import { version as e } from "../../version.js";
import { getConsoleStyle as t } from "./styledLogs.js";
//#region src/utils/init/usedUikitVersion.ts
var n = (e) => console.log("%c%s", t(), e), r = () => {
	n(`RIO UIKIT Version ${e}\nhttps://uikit.developers.rio.cloud`);
};
//#endregion
export { r as usedUikitVersion };

//# sourceMappingURL=usedUikitVersion.js.map